import { TitleCardsList } from "Components/SelectableCard/Title";
import { Flex, Typography } from "antd";

const options = [
  {
    title: "Bachelor's",
    value: "Bachelors",
  },
  {
    title: "Master's",
    value: "Masters",
  },
];

export const BachelorsOrMasters = ({ selectedCard, setSelectedCard }) => {
  const { Title } = Typography;
  return (
    <Flex vertical justify="flex-start" align="flex-start">
      <Title style={{ fontSize: "18px", fontWeight: "500", textAlign: "left" }}>
        What degree are you applying for?
      </Title>
      <TitleCardsList
        options={options}
        selectedCard={selectedCard}
        setSelectedCard={setSelectedCard}
      />
    </Flex>
  );
};
